import { ImpactClaimLog, ImpactClaimStatus } from 'FeatureModules/Request/types/impactClaim.types';
import profileImage from 'assets/img/profile-image.svg';

const INTERNAL_AUTHOR = 'Internal';

export const getAuthor = (log: ImpactClaimLog): { name: string; icon: string } => {
  if (log.action === ImpactClaimStatus.APPROVED || log.action === ImpactClaimStatus.DENIED) {
    return { name: INTERNAL_AUTHOR, icon: profileImage };
  }

  return { name: `${log.user.firstName} ${log.user.lastName}`, icon: profileImage };
};
